import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Key West?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk can take 1–3 months, especially during busy travel seasons.",
  },
  {
    q: "Do I need to visit an office in Key West?",
    a: "No — most Key West travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Key West, but that's the point: you don't need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere in the Florida Keys.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order.",
  },
  {
    q: "Can I get an expedited passport if I've never had one before?",
    a: "Yes, but first-time applicants typically require an in-person acceptance clerk visit before documents can be submitted for expedited processing. We guide you through exactly what to do and where to go in the Key West area.",
  },
  {
    q: "What is the closest passport agency to Key West?",
    a: "The closest regional passport agency is the Miami Passport Agency, located at 1501 Biscayne Blvd, Suite 210, Miami, FL 33132 — approximately a 3.5-hour drive via US-1. However, regional agencies require appointments and are typically reserved for urgent travel emergencies. Fast Passport Center can often provide a faster, more predictable option using approved courier submission.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
  {
    q: "What if I need a child passport in Key West?",
    a: "Child passports (for minors 15 and under) require parental participation and an in-person acceptance step — both parents typically must consent. We provide clear instructions and a checklist so you know exactly what to do. Expedited processing options are available after the acceptance step.",
  },
  {
    q: "Can I get a passport if mine is lost or stolen?",
    a: "Yes. Lost or stolen passport replacements often require additional forms (including Form DS-64 to report the lost passport). We guide you through exactly what's needed and help ensure the correct process is followed to avoid delays.",
  },
];

export default function KeyWestFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Key West travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}
